export default function SkillsList({ skills }) {
  return (
    <div className="flex flex-wrap gap-2">
      {skills.map((skill, index) => (
        <span
          key={index}
          className="text-xs font-mono bg-stone-100 text-stone-600 px-2.5 py-1 rounded-sm"
        >
          {skill}
        </span>
      ))}
    </div>
  );
}
